export default "__VITE_ASSET__e1PSiOsT__"